export const extractRGBA = (colorInt: number) => {
  const r = (colorInt >> 16) & 255
  const g = (colorInt >> 8) & 255
  const b = colorInt & 255
  const a = ((colorInt >> 24) & 255) / 255
  return { r, g, b, a }
}
